<template>
  <el-collapse v-model="activeNames">
    <el-collapse-item title="基本信息" name="1">
      <info-item
        :title="['产品线名称', '产品线编码']"
        :data="[common.name, common.code]"
      ></info-item>
      <info-item
        :title="['所属产品大类', 'BFM状态']"
        :data="[common.typeName, `${common.bfmStatus === 0 ? '启用' : '停用'}`]"
      ></info-item>
      <info-item :title="['说明']" :data="[common.remark]"></info-item>
    </el-collapse-item>
    <el-collapse-item title="系统信息" name="2">
      <info-item
        :title="['更新时间', '更新人']"
        :data="[`${detail.gmtModifiedStr}`, detail.modifier]"
      ></info-item>
      <info-item :title="['同步时间']" :data="[detail.syncTimeStr]"></info-item>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import InfoItem from "@/components/base/detail-info-item.vue";
import { mapGetters } from "vuex";

export default {
  props: {
    detail: Object,
    common: Object,
  },
  components: {
    InfoItem,
  },
  computed: {
    // ...mapGetters({}),
  },
  data() {
    return {
      activeNames: ["1", "2"],
    };
  },
  methods: {},
};
</script>

<style lang="less">
@import "~@/styles/common.less";

.panel-item {
  padding: 0 10px;
  .el-col {
    display: flex;
    padding-bottom: 10px;
    padding-top: 10px;
  }
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
  &:last-child {
    .el-col {
      border: none;
    }
  }
  .link-after {
    &:last-child::after {
      content: "";
    }
  }
  .link-after::after {
    content: "、";
  }
}
</style>
